import { useState } from 'react'

import GymService from 'service/GymService'
import { ISaveGymTrainerReservation } from 'types/GymType'
import AuthUtil from 'utils/AuthUtil'

export default function useSaveGymTrainerReservation(resInfo: ISaveGymTrainerReservation, closeAfterSave: () => void) {
  const [loading, setLoading] = useState(false)
  const employeeId = AuthUtil.getEmployeeSummary()?.id

  const saveGymTrainerReservation = () => {
    setLoading(true)
    GymService.saveGymTrainerReservation({
      ...resInfo,
      id: 0,
      employeeId: employeeId,
      isCancel: false,
    })
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { saveGymTrainerReservation, loading }
}
